import { Organization } from "types";

/**
 * Requires at least 1 lowercase letter, 1 uppercase letter, 1 digit, and 1 special character.
 * Pair with a `min: 12` length rule (not encoded here since antd's `pattern` rule doesn't compose with `min`).
 */
export const PASSWORD_COMPLEXITY_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/;

/**
 * Default organization object used as fallback when no organization is selected
 * or when the user has no organizations
 */
export const DEFAULT_ORGANIZATION: Organization = {
  application_id: "Libertify" as const,
  name: null,
  id: null,
  created: "-",
  updated: "-",
  slug: "libertify",
};
